export default __webpack_public_path__ + "static/ailin1-04396296810ac9333d3711eb71ec7303.png";